// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a32521bd37cc359825e8","655":"6434870f3ba01171ffe8"}[chunkId] + ".js";
};